import { render, staticRenderFns } from "./MyAudio.vue?vue&type=template&id=ba720d9c&"
import script from "./MyAudio.vue?vue&type=script&lang=js&"
export * from "./MyAudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports